<template lang="pug">
    #ProtocoloEmpresa
        el-card.mb-4.box-card(
            shadow='never',
            :body-style='{ padding: "10px" }',
            style='margin: 20px'
        )
            h3.mb-3
                i.mdi.mdi-filter-variant.mr-2
                | Filtros

            .filtros__input.mb-3
                el-select(
                    v-model='protocolosSelecionados',
                    style='width: 50%',
                    placeholder='Selecione os protocolos',
                    multiple,
                    filterable,
                    value-key='idProtocolos'
                )
                    el-option(
                        v-for='protocolo in protocolos',
                        :key='protocolo.codigo',
                        :label='protocolo.descricao',
                        :value='protocolo.codigo'
                    )

                el-select(
                    v-model='empresasSelecionadas',
                    style='width: 50%',
                    placeholder='Selecione as empresas',
                    multiple,
                    filterable,
                    value-key='idEmpresas'
                )
                    el-option(
                        v-for='empresa in empresas',
                        :key='empresa.id',
                        :label='empresa.name',
                        :value='empresa.id'
                    )

            .filtros__botao
                BaseButton(
                    type='primary',
                    size='mini',
                    icon='el-icon-receiving',
                    @click='buscarQtdProtocolosPorEmpresa'
                ) Filtrar

        el-card.mb-4.box-card(
            shadow='never',
            :body-style='{ padding: "10px" }',
            style='margin: 20px'
        )

            el-table.px-2(
                v-loading='carregandoTabela',
                :data='paginaQtdProtocolosPorEmpresa.data ? paginaQtdProtocolosPorEmpresa.data.itens : []',
                size='mini'
            )
                el-table-column(
                    label='Empresa (Grupo)',
                    prop='nomeEmpresa',
                    sortable,
                    :min-width='25'
                )
                el-table-column(
                    label='Número de protocolos vinculados',
                    prop='quantidadeProtocolo',
                    sortable,
                    :min-width='25',
                    align='center'
                )
                el-table-column(label='Ação', :min-width='15', align='center')
                    .template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.el-icon-caret-bottom
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='visualizarProtocolosEmpresa(scope.row)'
                                ) Visualizar protocolos vinculados

                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='editarProtocolosEmpresa(scope.row)'
                                ) Editar protocolos vinculados

            .mt-4.px-2.justify-content-between.d-flex.align-items-center
                .totalizadores
                    label.mr-3 Empresas: {{ paginaQtdProtocolosPorEmpresa.data ? paginaQtdProtocolosPorEmpresa.data.totalItens : 0 }}
                    label Protocolos vinculados: {{ totalProtocolosVinculados }}

                el-pagination(
                    small,
                    background,
                    layout='prev, pager, next',
                    :page-size='paginacao.tamanho',
                    :current-page.sync='paginacao.pagina',
                    :total='paginaQtdProtocolosPorEmpresa.data ? paginaQtdProtocolosPorEmpresa.data.totalItens : 0',
                    @current-change='atualizarPagina'
                )

        ModalVisualizarProtocolosVinculados(
            :mostrar='mostrarModalVisualizarProtocolos',
            :empresa='empresaModalVisualizarProtocolos',
            @fechar='mostrarModalVisualizarProtocolos = false'
        )

        ModalEditarProtocolosVinculados(
            :mostrar='mostrarModalEditarProtocolos',
            :empresa='empresaModalEditarProtocolos',
            :protocolos='protocolos',
            @atualizar-tabela='buscarQtdProtocolosPorEmpresa',
            @fechar='mostrarModalEditarProtocolos = false',
            @setProtocolosHabilitados='setProtocolosHabilitados'
        )

        ModalEditarProtocoloDefault(
            :mostrar='mostrarModalEditarProtocoloDefault',
            :protocolos='listaProtocolosHabilitados',
            @atualizar-tabela='buscarQtdProtocolosPorEmpresa',
            @fechar='mostrarModalEditarProtocoloDefault = false',
            @setSelectedProtocoloAsDefault='setSelectedProtocoloAsDefault',
            @vincularProtocoloEmpresa='vincularProtocoloEmpresa'
        )
</template>

<script>
    import { ProtocolosService } from '@/services/ProtocolosService';
    import ModalEditarProtocolosVinculados from '@/components/adminRelatorios/ModalEditarProtocolosVinculados';
    import ModalVisualizarProtocolosVinculados from '@/components/adminRelatorios/ModalVisualizarProtocolosVinculados';
    import ModalEditarProtocoloDefault from '@/components/adminRelatorios/ModalEditarProtocoloDefault';
    import BaseButton from '@/components/vegaComponents/BaseButton.vue';

    export default {
        name: 'ProtocolosEmpresa',

        components: {
            ModalEditarProtocolosVinculados,
            ModalVisualizarProtocolosVinculados,
            ModalEditarProtocoloDefault,
            BaseButton
        },

        props: {
            empresas: {
                type: Array,
                required: true
            }
        },

        data() {
            return {
                protocolos: [],
                protocolosSelecionados: [],
                empresasSelecionadas: [],
                totalProtocolosVinculados: 0,

                paginaQtdProtocolosPorEmpresa: {},
                paginacao: {
                    pagina: 0,
                    tamanho: 10
                },

                mostrarModalVisualizarProtocolos: false,
                empresaModalVisualizarProtocolos: {},

                mostrarModalEditarProtocolos: false,
                empresaModalEditarProtocolos: {},

                mostrarModalEditarProtocoloDefault: false,
                listaProtocolosHabilitados: [],
                protocoloDefault: '',

                carregandoTabela: false,
                carregandoTotalizadores: false
            };
        },

        mounted() {
            this.buscarProtocolos();
            this.buscarEmpresas();
            this.buscarQtdProtocolosPorEmpresa();
        },

        methods: {
            buscarEmpresas() {
                this.$emit('buscarEmpresas');
            },

            async buscarProtocolos() {
                const buscarProtocolosResponse = await ProtocolosService.buscarProtocolos();
                this.protocolos = buscarProtocolosResponse.data;
            },

            async buscarQtdProtocolosPorEmpresa() {
                this.carregandoTabela = true;

                this.buscarTotalProtocolosVinculados();

                this.paginaQtdProtocolosPorEmpresa = await ProtocolosService.buscarQtdProtocolosPorEmpresa(
                    {
                        codigosProtocolo: this.protocolosSelecionados,
                        idsEmpresa: this.empresasSelecionadas
                    },
                    this.paginacao
                );
                this.carregandoTabela = false;
            },

            async buscarTotalProtocolosVinculados() {
                const { data } =
                    await ProtocolosService.buscarTotalProtocolosVinculados();
                this.totalProtocolosVinculados = data;
            },

            async vincularProtocoloEmpresa() {
                try {
                    const bodyData = {
                        items: [{
                            idEmpresa: this.empresaModalEditarProtocolos.idEmpresa,
                            codigos: this.listaProtocolosHabilitados.map(protocolo => {
                                return { codigo: protocolo.codigo };
                            }),
                            padrao: this.protocoloDefault
                        }]
                    };
                    await ProtocolosService.vincularProtocoloEmpresa(bodyData);
                    this.$notify.success({
                        message: 'Vinculação de protocolos a empresa realizado com sucesso!'
                    });
                    this.buscarQtdProtocolosPorEmpresa();
                    this.empresaModalEditarProtocolos = {};
                    this.listaProtocolosHabilitados = [];
                    this.protocoloDefault = '';
                } catch (e) {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao vincular os protocolos à empresa'
                    });
                }
            },

            atualizarPagina(pagina) {
                this.paginacao.pagina = pagina;
                this.buscarQtdProtocolosPorEmpresa();
            },

            visualizarProtocolosEmpresa(empresa) {
                this.empresaModalVisualizarProtocolos = empresa;
                this.mostrarModalVisualizarProtocolos = true;
            },

            editarProtocolosEmpresa(empresa) {
                this.empresaModalEditarProtocolos = empresa;
                this.mostrarModalEditarProtocolos = true;
            },

            fecharModalEditarProtocolos() {
                this.mostrarModalEditarProtocolos = false;
                this.mostrarModalEditarProtocoloDefault = true;
            },

            setProtocolosHabilitados(value) {
                this.listaProtocolosHabilitados = value;
                this.mostrarModalEditarProtocoloDefault = true;
            },

            setSelectedProtocoloAsDefault(value) {
                this.protocoloDefault = value;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .filtros__input {
        display: flex;
        align-items: flex-start;
        gap: 8px;
    }

    .filtros__botao {
        display: flex;
        justify-content: flex-end;
    }

    .el-table.px-2.el-table--fit.el-table--enable-row-hover.el-table--enable-row-transition {
        height: 350px;
        overflow: scroll;
    }
</style>
